<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To</p>
<br/>
<p style="text-align: center;">All the people of my hometown, El-Méghaier, for their love and support.</p>
<br/>
<p style="text-align: right;">Ammar Haouimi</p>
<br/>
<p style="text-align: center;">To</p><br/>
<p style="text-align: center;">My wife for her endless support.</p>
<p style="text-align: center;">My children: Imad, Ataf, Afaf, Souad, Amira; and my daughter in-law, Asma.</p>
<p style="text-align: center;">My adorable grandchildren, Dora and Ahmed.</p>
<br/>
<p style="text-align: right;">Rabah Bouguelaa</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?370da534